import { z } from "zod";

export const emailSchema = z.string().email("無効なメールアドレス形式です");
